import { cva, type VariantProps } from 'class-variance-authority';
import type {ComponentProps, ReactNode } from 'react';

import { cn } from './cn';

const buttonVariants = cva(
	'inline-flex items-center justify-center gap-2 rounded-button font-medium transition-colors ' +
		'disabled:pointer-events-none disabled:opacity-50 whitespace-nowrap',
	{
		variants: {
			variant: {
				primary: 'bg-primary-solid text-primary-fg hover:bg-primary-solid-hover',
				secondary: 'bg-surface text-fg border border-border-strong hover:bg-surface-muted',
				ghost: 'text-fg-muted hover:bg-surface-muted hover:text-fg',
				accent: 'bg-accent text-accent-fg hover:brightness-95',
			},
			size: {
				sm: 'h-8 px-3 text-sm',
				md: 'h-10 px-4 text-sm',
				lg: 'h-12 px-6 text-base',
			},
		},
		defaultVariants: { variant: 'primary', size: 'md' },
	},
);

type ButtonProps = ComponentProps<'button'> & VariantProps<typeof buttonVariants>;

export function Button({ className, variant, size, ...props }: ButtonProps): ReactNode {
	return <button className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}

export { buttonVariants };
